<a type="button" class="btn button" [ngClass]="['my-button-secondary', 'emergency-button']" (click)="showPopup()"> 
    <i class="fas fa-exclamation-triangle"></i> 
    <span class="emergency-label d-none ml-2 font-weight-bold" [ngClass]="[labelBreakpoint ? ('d-' + labelBreakpoint + '-inline-block') : 'd-inline-block']">Emergency</span>
</a>
